<template>
  <div>
    <b-modal id="resend-quote-modal"
             hide-header-close
             size="md" centered v-model="show">
      <b-button variant="close-btn" class='btn-container' @click="show = false">
        <i class="fas fa-times"></i>
      </b-button>
      <div class="quote-modal text-center">
        <strong>Do you want to send the quote?</strong>
        <button
          type="button"
          class="btn univ-btn btn-secondary"
          @click="resendQuote()"
        >
          Resend Quotes
        </button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import Api from "@/resource/Api";
export default {
  name: "ResendQuoteModal",
  props: {
    rowId: {
      required: true,
    },
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
async resendQuote() {
  let url = `v2/quote/resend-email?id=${this.rowId}`;
  let loader = this.$loading.show();

  try {
    const res = await Api.post(url);
    this.$notify(res.data.message, "success");
  } catch (err) {
        console.error(err);

    if(err.response.data.message=='Quote has been declined. Cannot resend email.'){
      this.$notify('Quote has been declined. Cannot resend email.', 'error');
    } else {
      this.$notify(err.message || "An error occurred", "error");
    }
  } finally {
    loader.hide();
    this.$bvModal.hide('resend-quote-modal');
  }
},

  },
};
</script>
<style scoped>
.quote-modal .univ-btn {
  margin-top: 20px;
}
</style>